export enum AdminBrandStatus {
  Public = 'PUBLIC',
  Private = 'PRIVATE',
  Draft = 'DRAFT',
}
